import React from "react";
import { useDispatch } from "react-redux";
import { TextField, Grid } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import {
  modifyAssetsAndDiscountsCreationAction,
  duplicateAssetsAndDiscountsCreationOrderAction
} from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {

  const { data, handleClose, payrollSelected, isDuplicate, handleCloseDuplicate } = props;
  const dispatch = useDispatch();

  const modify = (dataToSend) => {
    dispatch(modifyAssetsAndDiscountsCreationAction(dataToSend))
      .then((res) => res?.status === 200 && handleClose());
  }

  const duplicate = (dataToSend) => {
    dispatch(duplicateAssetsAndDiscountsCreationOrderAction(dataToSend))
      .then((res) => res?.status === 200 && handleCloseDuplicate());
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit
  } = useHandleForm(data, isDuplicate, payrollSelected, modify, duplicate, openValidationError);

  return (
    <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
      <Grid container item xs={12}>
        <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* codigo */}
          <TextField
            disabled={!isDuplicate}
            fullWidth
            margin={"none"}
            label={isDuplicate ? getLocalizedString("newConceptCode") : getLocalizedString("employeesProcessCodigoConcepto")}
            value={formData.code}
            onChange={(e) => setFormValue(e.target.value, "code")}
            inputProps={{ maxLength: 8 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* nombre */}
          <TextField
            required
            fullWidth
            margin={"none"}
            label={getLocalizedString("employeesProcessNombreConcepto")}
            value={formData.name}
            onChange={(e) => setFormValue(e.target.value, "name")}
            inputProps={{ maxLength: 60 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* ID del concepto */}
          <TextField
            fullWidth
            margin={"none"}
            label={getLocalizedString("conceptId")}
            value={formData.conceptID}
            onChange={(e) => setFormValue(e.target.value, "conceptID")}
            inputProps={{ maxLength: 8 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* Secuencia */}
          <TextField
            disabled
            fullWidth
            margin={"none"}
            label={getLocalizedString("calculationSequence")}
            value={data.order}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} style={{ padding: "10px 10px" }}> {/* Texto de ayuda */}
          <TextFieldMultiline
            fullWidth
            label={getLocalizedString("helpText")}
            rows={5}
            margin={"none"}
            value={formData.dataEntryHelp}
            onChange={(e) => setFormValue(e.target.value, "dataEntryHelp")}
            inputProps={{ spellCheck: 'false', maxLength: 250 }}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ paddingBottom: 20 }}>
        {
          isDuplicate &&
          <div style={{ paddingRight: 10 }}>
            <ButtonDialogAction onClick={handleCloseDuplicate} text={getLocalizedString("disagree")} />
          </div>
        }
        <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
      </Grid>
    </Grid>
  );
}

export default Form;
